import { RotatingLines } from "react-loader-spinner";
import {
  EMPTY_STRING,
  inventoryConstants,
  toggleSwitchButtonConstants,
} from "../../../constants";
import SimpleNumberField from "../../components/inputNumberField/SimpleNumberField";
import SelectDropDown from "../../components/selectDropdown/SelectDropdown";
import TableCustomHeader from "../../components/table/TableCustomHeader";
import {
  batchCostOfGoodsChange,
  batchStockPriceChange,
  excludeNullColumns,
  getBatchModalCogsColumn,
  getBatchModalGradeColumn,
  getBatchModalQuantityColumn,
  getBatchModalRarityColumn,
  getProductIfExist,
  getProductSubCategory,
  getQuantityPropertyToUpdate,
  handleBatchProductDelete,
  handleCalculateEachProductPercentage,
  handleEmptyOnFocus,
  handleLockOrUnlockTradeItem,
  handleRaritiesChange,
  handleShowNintendoCondition,
  isMarketPriceHigh,
  isStoreCustomProduct,
  isSystemProduct,
  onChangeProductCondition,
  onChangeProductQuantity,
  parseToDecimalNumber,
  parseToThousandSeperatorDecimalNumber,
} from "../../utility";
import { TRADING_CARD_CATEGORIES_ENUMS } from "../../../system/globalEnums";
import {
  DeleteIcon,
  EditIcon,
  LockIcon,
  UnLockIcon,
} from "../../../assets/icons/iconsProvider";

const getAddInvoiceColumns = (props) => {
  const {
    productTags,
    currentStore,
    tradeinMargin,
    markupPresets,
    handleEditCardClick,
    invoiceBatchInventory,
    setInvoiceBatchInventory,
  } = props;
  let columns = [
    {
      id: "title",
      name: "Title",
      selector: (row) => row.productName,
      cell: (row) => {
        return (
          <div className="d-flex flex-column">
            <TableCustomHeader
              id={`tool${row.id}`}
              label={
                <span className="inventory-cell-max-size product-title-max-width">
                  {row.productName}
                </span>
              }
              tooltopText={row.productName}
            />
            {getProductSubCategory(row.genre) ===
              TRADING_CARD_CATEGORIES_ENUMS.SYSTEM &&
              (currentStore[
                toggleSwitchButtonConstants.IS_SERIAL_NUMBER_REQUIRED_INVENTORY
              ] ||
                row?.serialNumber) && (
                <span
                  className={`${
                    row.serialNumber ? EMPTY_STRING : "text-danger"
                  } batch-seial-number-label`}
                >
                  S/N : {row?.serialNumber || "Required"}
                </span>
              )}
          </div>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    getBatchModalGradeColumn(
      invoiceBatchInventory,
      setInvoiceBatchInventory,
      currentStore
    ),
    {
      id: "condition",
      name: "Condition",
      selector: (row) => row.productCondition,
      cell: (row) => {
        return (
          <SelectDropDown
            menuPlacement="bottom"
            options={row.productConditionList}
            noOptionsMessage="No Type Found"
            placeHolder="Type"
            defaultPageSize={{
              value: row?.productCondition,
              label: handleShowNintendoCondition(
                row.consoleName,
                row?.productCondition
              ),
            }}
            handleChange={(e) =>
              onChangeProductCondition(
                markupPresets,
                row.id,
                e.value,
                false,
                invoiceBatchInventory,
                setInvoiceBatchInventory,
                tradeinMargin
              )
            }
            isDisabled={row?.isItemLocked}
            menuPortalTarget=""
            value={{
              value: row?.productCondition,
              label: handleShowNintendoCondition(
                row.consoleName,
                row?.productCondition
              ),
            }}
          />
        );
      },
      sortable: false,
      sortDirection: null,
    },
    getBatchModalRarityColumn(
      invoiceBatchInventory,
      setInvoiceBatchInventory,
      currentStore?.id,
      markupPresets,
      tradeinMargin
    ),
    {
      id: "type",
      name: "Type",
      selector: (row) => row.productType,
      cell: (row) => {
        return (
          <span className="inventory-cell-max-size">{row.productType}</span>
        );
      },
      sortable: false,
      sortDirection: null,
      width: "8%",
    },
    {
      id: "category",
      name: "Category",
      selector: (row) => row.consoleName,
      cell: (row) => {
        return (
          <span className="inventory-cell-max-size">{row.consoleName}</span>
        );
      },
      sortable: false,
      sortDirection: null,
    },
    {
      id: "marketPrice",
      name: "Market Price",
      selector: (row) => row.marketPrice,
      cell: (row) => {
        return (
          <span
            className={`inventory-cell-max-size ${
              isMarketPriceHigh(
                row.marketPrice,
                row.inStockPrice,
                productTags,
                isStoreCustomProduct(row, "apiSource")
                  ? row.tags
                  : row.tags.map((tag) => tag.label),
                row.isDataFetching,
                isStoreCustomProduct(row, "apiSource")
              )
                ? "text-danger"
                : ""
            }`}
          >
            {parseToThousandSeperatorDecimalNumber(row.marketPrice)}
          </span>
        );
      },
      sortable: false,
      sortDirection: null,
      width: "9%",
    },
    getBatchModalQuantityColumn(
      currentStore,
      invoiceBatchInventory,
      setInvoiceBatchInventory
    ),
    getBatchModalCogsColumn(
      invoiceBatchInventory,
      setInvoiceBatchInventory,
      handleEmptyOnFocus
    ),
    {
      id: "stockPrice",
      name: "Stock Price",
      selector: (row) => row.inStockPrice,
      cell: (row) => {
        return (
          <input
            key={row.inStockPrice}
            min={0}
            type="number"
            // value={row.inStockPrice}
            defaultValue={row.inStockPrice}
            onFocus={handleEmptyOnFocus}
            className={`input-textfield editable-inventory-cell-max-size trade-batch-input-fields ${
              isMarketPriceHigh(
                row.marketPrice,
                row.inStockPrice,
                productTags,
                isStoreCustomProduct(row, "apiSource")
                  ? row.tags
                  : row.tags.map((tag) => tag.label),
                row.isDataFetching,
                isStoreCustomProduct(row, "apiSource")
              )
                ? "border-danger"
                : ""
            }`}
            onBlur={(e) => {
              const inputValue = parseToDecimalNumber(e.target.value); // Convert to number
              batchStockPriceChange(
                row.id,
                inputValue,
                currentStore,
                markupPresets,
                invoiceBatchInventory,
                setInvoiceBatchInventory,
                true
              );
            }}
            disabled={row?.isItemLocked}
          ></input>
        );
      },
      sortable: false,
      sortDirection: null,
      width: "8%",
    },
    {
      id: "inStockPriceAnd",
      name: "",
      cell: (row) => {
        return getProductIfExist(row, (value, id) => {
          batchStockPriceChange(
            id,
            value,
            currentStore,
            invoiceBatchInventory,
            setInvoiceBatchInventory
          );
        });
      },
      sortable: false,
      width: "7%",
    },
    {
      id: "action",
      name: "",
      cell: (row) => {
        return row?.isDataFetching ? (
          <div className="d-flex justify-content-center align-items-center">
            <RotatingLines
              visible={true}
              height="20"
              width="20"
              color="grey"
              strokeColor="#6a18ed"
              strokeWidth="4"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
            />
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center gap-2">
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper"
              onClick={() =>
                handleBatchProductDelete(
                  row.id,
                  invoiceBatchInventory,
                  setInvoiceBatchInventory
                )
              }
            >
              <DeleteIcon className="cursor-pointer text-primary" />
            </button>
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper  ps-0 pe-0 mx-auto"
              onClick={() => {
                handleLockOrUnlockTradeItem(
                  currentStore,
                  invoiceBatchInventory,
                  setInvoiceBatchInventory,
                  row.id
                );
              }}
            >
              {row?.isItemLocked ? (
                <LockIcon className="cursor-pointer text-primary" />
              ) : (
                <UnLockIcon className="cursor-pointer " />
              )}
            </button>
            <button
              id={`modalTool${row.id}`}
              className="action-Button-Wrapper ps-0 pe-0"
              onClick={() => {
                handleEditCardClick(row);
              }}
            >
              <EditIcon className="cursor-pointer text-primary" />
            </button>
          </div>
        );
      },
      sortable: false,
      width: "8%",
    },
  ];
  let filteredColumns = excludeNullColumns(columns);
  return filteredColumns;
};

export { getAddInvoiceColumns };
